// pending-changes.guard.ts
import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { LoadingService } from '../service/loading.service';
import { Observable, of } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

// Functional Guard replacement for CanDeactivate
export const pendingChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
): Observable<boolean> | Promise<boolean> | boolean => {
  const loadingService = inject(LoadingService);

  if (loadingService.loading) {
    alert('Please wait until the operation completes.');
    return false;
  }

  return component.canDeactivate ? component.canDeactivate() : true;
};

